import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
  ElementRef, AfterViewInit
} from "@angular/core";
import { Chart } from 'chart.js';


@Component({
  selector: 'app-consulta-experimental',
  templateUrl: './consulta-experimental.component.html',
  styleUrls: ['./consulta-experimental.component.scss']
})
export class ConsultaExperimentalComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();
  @ViewChild("meuCanvas", {static: true}) canvas: ElementRef;

  statusMsg = null;
  status = 'info';
  precosUltimos12Meses = [];
  labelsChart = [];
  dataChart = [];
  chart = [];

  @Input() token = '';

  constructor() { }

  ngOnInit() {

    this.precosUltimos12Meses = this.consulta?.lista;

    for ( let i = 0; i < this.precosUltimos12Meses.length ; i++) {

      let dataString = this.precosUltimos12Meses[i]?.dataReferencia;
      let date = new Date(dataString);
      let mes = date.getMonth() + 1;
      let ano = date.getFullYear();
      let mesAno = mes + '/' + ano;
      this.labelsChart.push(mesAno);

      let precoString = this.precosUltimos12Meses[i]?.preco;
      this.dataChart.push(parseFloat(precoString));

    }

    this.labelsChart = this.labelsChart.reverse();
    this.dataChart = this.dataChart.reverse();

  }
  ngAfterViewInit() {
    const ctx = this.canvas.nativeElement.getContext('2d');
    const gradientFill = ctx.createLinearGradient(0, 0, 0, 200);
    gradientFill.addColorStop(0, "#5cffca");
    gradientFill.addColorStop(1, "#66ff");
    this.chart = new Chart(ctx , {
      type: 'line',
      data: {
        labels: this.labelsChart,
        datasets: [
          {
            data: this.dataChart,
            fill: true,
            label: "Preço Fipe",
            backgroundColor: gradientFill
          }
        ]
      },
      options: {
        responsive: true,
        plugins: {
          title: {
            display: true,
            text: 'Chart with Tick Configuration'
          }
        },
        scales: {
          y: {
            ticks: {
              // For a category axis, the val is the index so the lookup via getLabelForValue is needed
              callback: function(val) {
                return 'R$ ' + val;
              },
              color: 'red',
            }
          }
        }
      }
    });

}


  ngOnChanges() {
  }


}
